/**
 * Rastreio condicionado ao consentimento de cookies.
 *
 * Nada é carregado antes de o visitante aceitar:
 *  - Meta Pixel  -> consentimento de "Publicidade e marketing"
 *  - Google Analytics 4 -> consentimento de "Desempenho e análise"
 *
 * IDs configurados no build (frontend/.env):
 *  REACT_APP_META_PIXEL_ID=123456789012345
 *  REACT_APP_GA_ID=G-XXXXXXXXXX
 *
 * Sem ID definido, o script correspondente nunca é injetado.
 * Se o utilizador rejeitar depois de ter aceitado, deixamos de carregar/enviar
 * eventos (os cookies já criados não são apagados, por decisão do cliente).
 */

const PIXEL_ID = (process.env.REACT_APP_META_PIXEL_ID || "").trim();
const GA_ID = (process.env.REACT_APP_GA_ID || "").trim();

const state = { pixel: false, ga: false, marketing: false, analytics: false };

function injectScript(src, id) {
  if (document.getElementById(id)) return;
  const s = document.createElement("script");
  s.async = true;
  s.src = src;
  s.id = id;
  document.head.appendChild(s);
}

function loadMetaPixel() {
  if (state.pixel || !PIXEL_ID) return;
  (function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = true;
    t.id = "meta-pixel";
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  window.fbq("init", PIXEL_ID);
  window.fbq("track", "PageView");
  state.pixel = true;
}

function loadGA() {
  if (state.ga || !GA_ID) return;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  injectScript(`https://www.googletagmanager.com/gtag/js?id=${GA_ID}`, "ga4-script");
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { anonymize_ip: true });
  state.ga = true;
}

/** Aplica as preferências de cookies guardadas. Chamar no arranque e ao guardar escolhas. */
export function applyConsent(prefs) {
  state.marketing = !!prefs?.marketing;
  state.analytics = !!prefs?.analytics;
  if (state.marketing) loadMetaPixel();
  if (state.analytics) loadGA();
}

/** Envia um PageView em mudanças de rota (SPA), respeitando o consentimento. */
export function trackPageView(path) {
  if (state.marketing && state.pixel && window.fbq) {
    window.fbq("track", "PageView");
  }
  if (state.analytics && state.ga && window.gtag && GA_ID) {
    window.gtag("event", "page_view", { page_path: path });
  }
}

/** Evento personalizado (ex.: candidatura enviada, registo concluído). */
export function trackEvent(name, params = {}) {
  if (state.marketing && state.pixel && window.fbq) {
    window.fbq("trackCustom", name, params);
  }
  if (state.analytics && state.ga && window.gtag) {
    window.gtag("event", name, params);
  }
}

export const trackingConfig = { hasPixel: !!PIXEL_ID, hasGA: !!GA_ID };
